declare global {
  interface Navigator {
    msSaveBlob?: (blob: any, defaultName?: string) => boolean;
  }
}

export function downloadFile(
  data: ArrayBuffer,
  filename: string,
  mime?: string
) {
  const blob = new Blob([data], { type: mime || 'application/octet-stream' });

  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    window.navigator.msSaveBlob(blob, filename);
    return;
  }

  const downloadLink = document.createElement('a');
  const fileURL = window.URL.createObjectURL(blob);

  downloadLink.style.display = 'none';
  downloadLink.href = fileURL;
  downloadLink.setAttribute('download', filename);
  // allows to download files in safari even when popup blocking is enabled
  if (typeof downloadLink.download === 'undefined') {
    downloadLink.setAttribute('target', '_blank');
  }

  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);

  setTimeout(() => {
    window.URL.revokeObjectURL(fileURL);
  });
}
